<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title>
          {{ $t('createKeystore') }}
        </v-card-title>
        <v-list-item>
          <v-list-item-content>
            <v-form ref="form" v-model="valid">
              <v-text-field
                id="3a66fbfd"
                v-model="name"
                :label="$t('name')+`*`"
                :counter="maxCharacters"
                :rules="[rules.required, rules.minMax]"
              ></v-text-field>
              <v-row>
                <v-col cols="6">
                  <v-select
                    id="8a642a24"
                    v-model="type"
                    :items="typeList"
                    :label="$t('select') +' ' + $t('type')+`*`"
                    chips
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-if="isPKCS11 || isMPCM"
                    id="4b13e928"
                    v-model="providerName"
                    :label="isPKCS11 ? $t('providerName')+`*` : $t('userName')+`*`"
                    :counter="maxCharacters"
                    :rules="[rules.required, rules.minMax]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    id="d09a57c0"
                    v-model="password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :label="$t('password')+`*`"
                    :counter="maxCharacters"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="[rules.required, rules.minMax]"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    id="ce089a11"
                    v-model="rePassword"
                    :append-icon="showRePassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :label="$t('passwordConfirmation')+`*`"
                    :counter="maxCharacters"
                    :type="showRePassword ? 'text' : 'password'"
                    :rules="[rules.required, rules.minMax, rules.passwordMatch]"
                    validate-on-blur
                    @click:append="showRePassword = !showRePassword"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-switch id="e007e7c2" v-model="autoActivation" class="mx-3" :label="$t('autoActivation')"></v-switch>
              <small>*{{ $t('indicatesRequiredField') }}</small>
            </v-form>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-btn id="b36892ab" class="ma-2" color="primary" :disabled="!valid" @click="createKeyStore">{{ $t('create') }}</v-btn>
          <v-btn id="0bf1dd6e" class="ma-2" @click="back">{{ $t('back') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import keystores from './../../api/keystores'
import keyStoreType from './KeyStoreType'
import { showToastSuccess, showToastError } from '../../event-bus'

export default {
  name: 'CreateKeyStore',

  data() {
    return {
      valid: true,
      maxCharacters: 255,
      name: null,
      typeList: keyStoreType,
      type: null,
      providerName: null,
      password: null,
      rePassword: null,
      autoActivation: false,
      showPassword: false,
      showRePassword: false,
      rules: {
        required: v => !!v || this.$t('validation.requiredField'),
        minMax: v => (v && v.length <= this.maxCharacters) || this.$t('validation.mustBeLessThan', { max: this.maxCharacters }),
        passwordMatch: v => (v === this.password) || this.$t('validation.passwordMustBeIdentical')
      }
    }
  },

  computed: {
    isInternal() {
      return this.type === 'INTERNAL'
    },
    isPKCS11() {
      return this.type === 'PKCS11'
    },
    isMPCM() {
      return this.type === 'MPCM'
    }
  },

  async mounted() {
    await keystores.isMpcmProviderConfigured()
      .then(resp => {
        this.typeList = resp !== true ? this.typeList.filter(item => item !== 'MPCM') : this.typeList
      })
      .catch(() => showToastError(this.$t('toastMessage.errorWhileRetrievingData')))
  },

  methods: {
    async createKeyStore() {
      if (!this.$refs.form.validate()) {
        return
      }

      let keyStoreCreationRequest = {
        keyStore: {
          name: this.name,
          type: this.type,
          providerName: !this.isInternal ? this.providerName : null
        },
        password: this.password,
        autoActivation: this.autoActivation
      }

      try {
        await keystores.createKeyStore(keyStoreCreationRequest)
        showToastSuccess(this.$t('toastMessage.succesfullyCreated'))
        this.back()
      } catch (error) {
        let errorMsg = this.$t('toastMessage.errorWhileRetrievingData')
        if (error.response != null) {
          switch (error.response.data.code) {
            case 'ALREADY_EXISTS':
              errorMsg = this.$t('toastMessage.alreadyExist')
          }
        }
        showToastError(errorMsg)
      }
    },

    back() {
      this.$router.go(-1)
    }
  }
}
</script>
